const urls = {
    NOTIFICATIONS_URL: "system/notification",
    THREADS_URL: "system/notification-thread"
}

import genericService from '../genericService';

export default {
    async getNotifications(callback){
        await genericService.get(urls.NOTIFICATIONS_URL).then(callback);
    },
    async addNotification(body, callback){
        await genericService.post(urls.NOTIFICATIONS_URL, body).then(callback);
    },
    async getThreads(callback){
        await genericService.get(urls.THREADS_URL).then(callback);
    },
    async addThread(body, callback){
        await genericService.post(urls.THREADS_URL, body).then(callback);
    },
    async editThread(body, callback){
        await genericService.put(urls.THREADS_URL, body).then(callback);
    }

}